import React from 'react';
import Home from './pages/Home'
import Theme from './componenets/Theme'
const App = () => {
  return (
    <React.Fragment>
      <Theme />
      <Home />
    </React.Fragment>
  );
}

export default App;
